import { CircularProgress } from '@mui/material';

export const SelectIconArrowSpinner = () => {
  return (
    <CircularProgress
      color="primary"
      size={14}
      sx={{
        userSelect: 'none',
        pointerEvents: 'none',
        mr: 1,
        minWidth: '24px',
        minHeight: '24px',
      }}
    />
  );
};

SelectIconArrowSpinner.displayName = 'SelectIconArrowSpinner';
